import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timeline = _resolveComponent("Timeline")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Timeline, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.TimeLineTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.TimeLineTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.TimeLineTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.TimeLineTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.TimeLineTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.TimeLineTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.TimeLineTypeConst.PLACEHOLDER),
        value: _ctx.getPropertyValue(_ctx.TimeLineTypeConst.VALUE),
        align: _ctx.getCatalogValue(_ctx.TimeLineTypeConst.ALIGN),
        layout: _ctx.getCatalogValue(_ctx.TimeLineTypeConst.LAYOUT),
        datakey: _ctx.getPropertyValue(_ctx.TimeLineTypeConst.DATAKEY),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event)),
        onClick: _ctx.clicktest
      }, {
        content: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, "content", {
            slotProps: { data: slotProps.item, index: slotProps.index, control: _ctx.ControlTypeConst.CTTIMELINE }
          })
        ]),
        opposite: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, "opposite", {
            slotProps: { data: slotProps.item, index: slotProps.index, control: _ctx.ControlTypeConst.CTTIMELINE }
          })
        ]),
        marker: _withCtx((slotProps) => [
          _renderSlot(_ctx.$slots, "marker", {
            slotProps: { data: slotProps.item, index: slotProps.index, control: _ctx.ControlTypeConst.CTTIMELINE }
          })
        ]),
        connector: _withCtx(() => [
          _renderSlot(_ctx.$slots, "connector", {
            slotProps: { data: _ctx.slotProps.item, index: _ctx.slotProps.index, control: _ctx.ControlTypeConst.CTTIMELINE }
          })
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "value", "align", "layout", "datakey", "modelValue", "onClick"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.TimeLineTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}